import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SolutionOnboardingComponent} from './solution-onboarding.component';
import {SolutionOnboardingRoutingModule} from 'src/app/main/solution-onboarding/solution-onboarding-routing.module';
import {SharedModule} from 'src/app/shared/shared.module';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatCardModule} from '@angular/material/card';
import {PaginatorModule} from 'src/app/components/paginator/paginator.module';
import {SolutionSummaryComponent} from './solution-summary/solution-summary.component';
import {PlayButtonModule} from 'src/app/components/play-button/play-button.module';
import {CapabilityCardComponent} from './capability-card/capability-card.component';
import {IconsModule} from 'src/app/icons/icons.module';
import {TableModule} from 'src/app/table/table.module';
import { SolutionVersionsComponent } from './solution-versions/solution-versions.component';
import { SolutionVersionDetailsComponent } from './solution-version-details/solution-version-details.component';
import {MatDividerModule} from '@angular/material/divider';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {SidenavHeaderModule} from 'src/app/components/sidenav-header/sidenav-header.module';
import {ToolbarModule} from 'src/app/layout/toolbar/toolbar.module';
import {AddSolutionFormComponent} from './add-solution-form/add-solution-form.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ErrorModule} from 'src/app/components/error/error.module';
import {AddBuildVersionFormComponent} from './add-build-version-form/add-build-version-form.component';
import {AddCapabilityDialogComponent} from './add-capability-dialog/add-capability-dialog.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {MatSortModule} from '@angular/material/sort';
import {MatSelectModule} from '@angular/material/select';
import { ErrorDialogModule } from 'src/app/components/error-dialog/error-dialog.module';
import { SearchFilterModule } from 'src/app/components/search-filter/search-filter.module';
import { InstallSpecDialogComponent } from './install-spec-dialog/install-spec-dialog.component';
import { ExternalPackageComponent } from './external-package/external-package.component';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';

@NgModule({
  declarations: [
    SolutionOnboardingComponent,
    SolutionSummaryComponent,
    CapabilityCardComponent,
    SolutionVersionsComponent,
    SolutionVersionDetailsComponent,
    AddSolutionFormComponent,
    AddBuildVersionFormComponent,
    AddCapabilityDialogComponent,
    InstallSpecDialogComponent,
    ExternalPackageComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    SolutionOnboardingRoutingModule,
    MatMenuModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatCardModule,
    PaginatorModule,
    PlayButtonModule,
    IconsModule,
    TableModule,
    MatDividerModule,
    MatTabsModule,
    MatExpansionModule,
    SidenavHeaderModule,
    ToolbarModule,
    ReactiveFormsModule,
    FormsModule,
    ErrorModule,
    MatSlideToggleModule,
    ClipboardModule,
    MatSortModule,
    MatSelectModule,
    ErrorDialogModule,
    SearchFilterModule,
    BreadcrumbModule
  ]
})
export class SolutionOnboardingModule {
}
